import { Theme, useMediaQuery } from '@mui/material';

import { MOBILE_BREAK_POINT } from 'pages/landing/v2/Main/constants';

export default function useIsMobile(breakpoint: number = MOBILE_BREAK_POINT) {
    return useMediaQuery<Theme>((theme) => theme.breakpoints.down(breakpoint), {
        noSsr: true
    });
}
